import Tabs from "@/components/Tabs";
import useCapabilities, { DOMAIN, PERMISSION, useHasCapabilityBool } from "@/hooks/useCapabilities";
import { useFlags } from "@/hooks/useFeatureFlags";
import AppLayout from "@/layouts/AppLayout";
import { Path, useNavigate } from "@/router";
import { useLocation } from "react-router-dom";

function BillingTabs() {
  const location = useLocation();
  const { pathname } = location;
  const navigate = useNavigate();
  const flags = useFlags();
  const { capabilities } = useCapabilities();
  const canViewPersonBilling = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonBilling
  });

  const showFinanceTab = !!flags["backoffice-grp"] && capabilities.domains.includes(DOMAIN.BENEFIT_PROGRAMS);

  const tabItems: { label: string; to: Path }[] = [
    {
      label: "Orders",
      to: "/billing/orders"
    },
    {
      label: "Payments",
      to: "/billing/payments"
    },
    {
      label: "Dues Management",
      to: "/billing/dues-management"
    },
    ...(canViewPersonBilling
      ? [
          {
            label: "Payout Profiles",
            to: "/billing/payout-profiles" as Path
          }
        ]
      : []),
    ...(showFinanceTab
      ? [
          {
            label: "Finance",
            to: "/billing/finance" as Path
          }
        ]
      : [])
  ];

  return (
    <Tabs
      tabItems={tabItems.map(({ label, to }) => ({
        label,
        onClick: () => navigate(to),
        active: (pathname.endsWith("/") ? pathname.slice(0, -1) : pathname) === to
      }))}
    />
  );
}

export default function TabLayout({ children }: { children: React.ReactNode }) {
  return (
    <AppLayout>
      <BillingTabs />
      <div className="flex flex-col">{children}</div>
    </AppLayout>
  );
}
